import { render } from "./heart-rate.vue?vue&type=template&id=03f70cc1&scoped=true"
import script from "./heart-rate.vue?vue&type=script&lang=js"
export * from "./heart-rate.vue?vue&type=script&lang=js"

import "./heart-rate.vue?vue&type=style&index=0&id=03f70cc1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f70cc1"]])

export default __exports__